import UserRepo from "@/repositories/user";

// Init state
const jwt = localStorage.getItem("jwt");
const user = localStorage.getItem("user");

const initialState =
  jwt && user
    ? { status: { loggedIn: true }, token: jwt, user: JSON.parse(user) }
    : { status: {}, token: null, user: null };

export default {
  namespaced: true,
  state: initialState,

  mutations: {
    LOGIN_REQUEST(state) {
      state.status = { loggingIn: true };
    },

    LOGIN_SUCCESS(state, jwt) {
      state.status = { loggedIn: true };
      state.token = jwt;
    },

    LOGIN_FAILURE(state) {
      state.status = {};
      state.token = null;
      state.user = null;
    },

    LOGOUT(state) {
      state.status = {};
      state.token = null;
      state.user = null;
    },

    USER_REQUEST(state) {
      state.status = { userRequest: true };
    },

    USER_SUCCESS(state, user) {
      state.status = { userSuccess: true };
      state.user = user;
    },

    USER_FAILURE(state) {
      state.status = { userFailure: true };
      state.user = null;
    }
  },

  actions: {
    /**
     * Perform login action.
     * If success, save a JWT in localStorage
     * @param {*} context
     * @param {Object} payload User credentials
     */
    async login({ commit, dispatch }, payload) {
      try {
        commit("LOGIN_REQUEST");

        const { data } = await UserRepo.login(payload);

        // Store token in local storage
        localStorage.setItem("jwt", data.jwt_token);

        await dispatch("getConnectedUser");

        commit("LOGIN_SUCCESS", data.jwt_token);

        return data;
      } catch (error) {
        commit("LOGIN_FAILURE");
        console.error("Login action", error);
        throw error;
      }
    },

    async getConnectedUser({ commit }) {
      try {
        commit("USER_REQUEST");

        const { data } = await UserRepo.me();

        // Store user info in local storage
        localStorage.setItem("user", JSON.stringify(data));

        commit("USER_SUCCESS", data);
        return data;
      } catch (error) {
        commit("USER_FAILURE");
        console.error("User action", error);
        throw error;
      }
    },

    /**
     * Perform logout.
     * Reset state
     */
    logout({ commit }) {
      // Remove jwt from local storage
      localStorage.removeItem("jwt");

      // Remove user from local storage
      localStorage.removeItem("user");

      commit("LOGOUT");
    }
  },
  getters: {
    userRole: state => {
      return state.user ? state.user.role : null;
    }
  }
};
